/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-looking-for',
  templateUrl: './looking-for.page.html',
  styleUrls: ['./looking-for.page.scss'],
})
export class LookingForPage implements OnInit {

  protected saveChangesButton : boolean = false;

  protected nextButtonHidden : boolean = true;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected userData : any; //var for logged 'user' data

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected newGenericOptions : any;  //takes every interest chosen by user (ionViewDidLoad())

  constructor( public navParams: NavParams, private modalCtrl: ModalController) {
    this.userData = this.navParams.get('theSoul'); //getting 'user' data
    this.newGenericOptions = new Set(this.userData.lookingFor);
  }
  ngOnInit(): void {
  }


  //gets selected option from button
  setNewOption(value : string){
    
    this.showSaveButton();

    //verifica se ta no array de interesses ja
    if(!this.hasOption(value)){
      this.addOption(value);  //e vai la e adiciona
    } else {
      this.removeOption(value);
    }

  }

  //closes modal without saving
  exitButton(){
    this.modalCtrl.dismiss('exitModal');
  }

  //switches 'exitButton' to 'saveButton'
  showSaveButton(){
    this.saveChangesButton = true;
  }

  //saves changes made by user
  saveButton(){
    this.saveOption();
    this.modalCtrl.dismiss('exitModal');    
  }

  //checks if 'newOption' was already in array
  hasOption(newOption : string){
    return this.newGenericOptions.has(newOption);
  }

  //adds option into 'newGenericOptions'
  addOption(chosenOption : string){ 
    switch(chosenOption){    //checks if user's choice was 'dontKnowYet' or 'openForAnything'
      case 'dontKnowYet':
        this.newGenericOptions.clear(); //if it is, it clears the options chosen
        break;
      
      case 'openForAnything':
        this.newGenericOptions.clear(); // ''
        break;

      default:
        if(this.hasOption('dontKnowYet')){ //if it isn't, and 'dontKnowYet' || 'openForAnything' was chosen before
          this.removeOption('dontKnowYet');   //... it removes it from 'newGenericOptions'
        
        } else if(this.hasOption('openForAnything')){ // ''
          this.removeOption('openForAnything'); //''

        }

        break;
    }

    this.newGenericOptions.add(chosenOption); //... and then adds the option
  }

  //removes option from 'newOption'
  removeOption(chosenOption : string){
    this.newGenericOptions.delete(chosenOption);
  }

  //compares options 
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  compareOptions(userOptions : any){
    const possibleOptions = new Set(['seriousRelationship', 'justADate', 'friendship', 'openRelationship']);
    
    //checks if both sets are the same size
    if(userOptions.size !== possibleOptions.size){
      //alert('os sets não são iguais');
      return false;

    }

    //... and then sees if every option on 'newGenericOptions' is on 'possibleOptions'
    for(const userOption in userOptions){
      if(!possibleOptions.has(userOption)){
        //alert('os sets não são iguais');
        return false;

      }
    }

    //alert('os sets são iguais');
    return true;
  }


  //sets 'nextButton's visibility
  hideNextButton(choice : boolean){
    this.nextButtonHidden = choice;
  }

  //"goes back" 1 modal and saves
  backButton(){
    this.saveOption();
    this.modalCtrl.dismiss('backModal');
  }

  //saves info, checks if interest is empty, and closes modal
  nextButton(){
    this.saveOption();
    this.modalCtrl.dismiss('nextModal');    
  }

  //saves info
  saveOption(){
    //if 'dontKnow yet' was chosen
    if(this.hasOption('dontKnowYet')){
      this.newGenericOptions.clear(); //it empties the set
      this.addOption('dontKnowYet');    //... and only adds 'dontKnowYet'

    } 
    
    //if 'openForAnything', or just every option possible
    else if(this.hasOption('openForAnything') || this.compareOptions(this.newGenericOptions)){
      this.newGenericOptions.clear();
      this.addOption('openForAnything');

    }

    this.userData.lookingFor = Array.from(this.newGenericOptions);    //and adds its values into 'genericOption'
    //console.log("settado: ", this.userData.lookingFor);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InterestPage');
  }
}
